import api from 'api'
import { Applications } from 'types/Application'
import { fetchWithToken } from 'utils'

const fetchApplications = async (): Promise<Applications> => {
  const route = `applications`

  return fetchWithToken({
    method: 'GET',
    resource: api.applications,
    path: route,
    useGoToBasePath: true,
    useV5: false,
  })
    .then((response: Response) => {
      if (response.status === 200) {
        return response.json()
      } else {
        return { items: [] }
      }
    })
    .catch((err: Error) => {
      // Something wrong happened during the fetch
      console.error(err.toString())
    })
}

export default fetchApplications
